import { render, staticRenderFns } from "./SiloProfileVisualizationCanvas.vue?vue&type=template&id=0bcbe608&scoped=true&"
import script from "./SiloProfileVisualizationCanvas.vue?vue&type=script&lang=js&"
export * from "./SiloProfileVisualizationCanvas.vue?vue&type=script&lang=js&"
import style0 from "./SiloProfileVisualizationCanvas.vue?vue&type=style&index=0&id=0bcbe608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcbe608",
  null
  
)

export default component.exports